import { TranslocoService } from '@jsverse/transloco';

/**
 * "Quedan X día(s)/hora(s)" — usado por plan-view y plan-view-price (antes
 * duplicado en ambos con la misma lógica de pluralización hardcodeada en
 * español). Namespace `plan` en assets/i18n/{es,en,pt}.json.
 */
export function trialRemainingLabel(transloco: TranslocoService, days: number, hours: number): string {
  if (days === 0) {
    return transloco.translate(hours === 1 ? 'plan.trialRemainingHour' : 'plan.trialRemainingHours', { hours });
  }
  return transloco.translate(days === 1 ? 'plan.trialRemainingDay' : 'plan.trialRemainingDays', { days });
}
